import scheduleFiveOverview from "./schedule-five-overview/all";

export default function (nameAction, namePage){
    if (nameAction === 'overview') scheduleFiveOverview();
}
